import {
  CreateCompanyRequestSchema,
  CreateCompanyResponseSchema,
  GetCompanyResponseSchema,
  UpdateCompanyRequestSchema,
  UpdateCompanyResponseSchema,
  type CreateCompanyRequest,
  type CreateCompanyResponse,
  type GetCompanyResponse,
  type UpdateCompanyRequest,
  type UpdateCompanyResponse,
} from '@crv/contracts/tenancy';

import { apiGet, apiPatch, apiPost } from './http-client';

export async function createCompany(input: CreateCompanyRequest): Promise<CreateCompanyResponse> {
  const payload = CreateCompanyRequestSchema.parse(input);
  return apiPost('/v1/companies', CreateCompanyResponseSchema, payload);
}

export async function getCompany(companyId: string): Promise<GetCompanyResponse> {
  return apiGet(`/v1/companies/${companyId}`, GetCompanyResponseSchema);
}

export async function updateCompany(request: UpdateCompanyRequest): Promise<UpdateCompanyResponse> {
  const payload = UpdateCompanyRequestSchema.parse(request);
  return apiPatch(`/v1/companies/${payload.companyId}`, UpdateCompanyResponseSchema, payload);
}
